import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import config from '../config/environment';

const Header = () => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          navigate('/login');
          return;
        }

        const response = await axios.get(`${config.API_BASE_URL}/auth/me`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (response.data?.user) {
          setUser(response.data.user);
        }
      } catch (error) {
        console.error('Failed to fetch user profile:', error);
        if (error.response?.status === 401) {
          localStorage.removeItem('token');
          navigate('/login');
        }
      }
    };

    fetchUserProfile();
  }, [navigate]);

  return (
    <div style={{
      width: '100%', 
      height: isMobile ? 80 : 111,
      borderBottom: '1px solid #A8B9CA',
      display: 'flex',
      justifyContent: 'flex-end',
      padding: isMobile ? '16px 20px' : '24px 32px',
      position: isMobile ? 'fixed' : 'relative',
      top: isMobile ? 0 : 'auto',
      left: isMobile ? 0 : 'auto',
      zIndex: isMobile ? 999 : 'auto',
      background: 'white'
    }}>
      <div style={{display: 'flex', alignItems: 'center', gap: isMobile ? 12 : 24}}>
        {/* Bell Icon - Hide on mobile to save space */}
        {!isMobile && (
          <div style={{
            width: 32,
            height: 32,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <svg width="24" height="28" viewBox="0 0 24 28" fill="none">
              <path d="M12 28C13.65 28 15 26.65 15 25H9C9 26.65 10.35 28 12 28ZM21 19V12C21 7.93 18.36 4.36 14.5 3.68V3C14.5 1.61 13.39 0.5 12 0.5C10.61 0.5 9.5 1.61 9.5 3V3.68C5.63 4.36 3 7.92 3 12V19L0 22V23.5H24V22L21 19Z" fill="#131A1A"/>
            </svg>
          </div>
        )}

        {/* Profile Section */}
        <div style={{display: 'flex', alignItems: 'center', gap: isMobile ? 8 : 16}}>
          <div style={{
            width: isMobile ? 35 : 45,
            height: isMobile ? 35 : 45,
            background: '#D9D9D9',
            borderRadius: '50%',
            overflow: 'hidden'
          }}>
            {user?.photo ? (
              <img 
                src={user.photo} 
                alt={user.name} 
                style={{width: '100%', height: '100%', objectFit: 'cover'}}
              />
            ) : (
              <div style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '20px',
                color: '#666'
              }}>
                {user?.name?.charAt(0)}
              </div>
            )}
          </div>
          <div>
            <div style={{
              color: '#000',
              fontSize: isMobile ? '14px' : '16px',
              fontFamily: 'Outfit',
              fontWeight: '600',
              whiteSpace: 'nowrap'
            }}>
              {user?.name || 'Loading...'}
            </div>
            <div style={{
              color: '#666',
              fontSize: isMobile ? '12px' : '14px',
              fontFamily: 'Outfit',
              whiteSpace: 'nowrap'
            }}>
              {user?.role?.charAt(0).toUpperCase() + user?.role?.slice(1) || 'User'}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
